import LocalizedStrings from 'react-localization';

export const englishStrings = {
  low: 'The employee match all of the shift requirements.',
  missingSkills: {
    mandatory: 'Missing mandatory skills.',
    optional: 'Missing optional skills.'
  },
  staffCannotBeAssigned: {
    message: 'This staff member cannot be rostered on this shift.',
    underAgeNightShift: 'They are under 18 years old and the shift extends 22.00 hours.'
  },
  overlappingShifts: {
    message: 'This staff member cannot be rostered on this shift.',
    description: 'This shift is too close to another shift they are already assigned to.'
  },
  beforeStartShift: {
    message: 'This shift begins before opening time.',
    description: (time: string) => `This shift begins before the opening time (${time}).`
  },
  afterEndShift: {
    message: 'This shift ends after closing time.',
    description: (time: string) => `This shift ends after the closing time (${time}).`
  },
  shiftAtOtherLocation: {
    message: 'This employee already has a shift at another location.'
  },
  reassignedAtOtherLocation: {
    message: 'This employee has also been reassigned to another location.'
  },
  probationaryEmployee: {
    one: 'This probationary employee is rostered to work the final shift of the day alone.',
    two: 'This probationary employee is rostered to work the final shift of the day with another probationary employee.',
    multiple: (numberOfEmployees: number) =>
      `This probationary employee is rostered to work the final shift of the day with another ${numberOfEmployees} probationary employees.`
  },
  paidOrPreferredDayOff: {
    message: 'This staff member has requested a day off on this day.'
  },
  rosteredDayOff: {
    message: 'This staff member has a rostered day off on this day.'
  },
  availableHoursDoNotFitShiftHours: {
    message: (name: string) => `${name} has been rostered for a shift which does not fit with their requested hours.`,
    detailsAvailable: (availableHours: string) => `Staff Availability: ${availableHours}`,
    detailsShift: (shiftHours: string) => `Shift Hours: ${shiftHours}`
  },
  managerRequired: 'A Manager or a Deputy Manager should be rostered for at least one shift in this roster.',
  leftCompany: (date: string) => `This staff member's leave date is ${date} and is no longer available.`,
  role: {
    invalidRole: `This role is not valid for this shift.`,
    info: 'The shift duration exceeds the contracted maximum for this role.'
  },
  breakMinimumSingle: (shiftLengthHours: number, breakLengthMinutes: number) =>
    `A shift longer than ${shiftLengthHours} hours must have a break of at least ${breakLengthMinutes} minutes.`,
  breakMinimumSplit: (shiftLengthHours: number, breakLengthMinutes: number) =>
    `A shift longer than ${shiftLengthHours} hours must have at least ${breakLengthMinutes} minutes of break time.`,
  nobodyRostered: (shiftHours: string) => `Nobody is rostered to work the ${shiftHours} shift.`
};

export type WarningStringsType = typeof englishStrings;

export const strings = new LocalizedStrings({
  en: englishStrings
});
